import { Item } from "./TabsItem.styled";

const TabsItem = ({ title, onClick, active }) => {
  return (
    <Item active={active} onClick={onClick}>
      {title}
    </Item>
  );
};

export default TabsItem;
